<template>
  <div>
    <form class="password-recovery-reset" @submit.prevent="resetPassword">
      <h1 class="password-recovery-reset__title">
        {{ $t("auth.passwordReset.title") }}
      </h1>

      <transition name="fade">
        <div class="password-recovery-reset__error-text" v-if="!!error">
          {{ error }}
        </div>
      </transition>

      <div class="password-recovery-reset__email-box">
        <InputLabel>
          <template #label>
            {{ $t("auth.passwordReset.newPassword") }}
          </template>

          <input
            type="password"
            placeholder=""
            name="password"
            v-model="password"
            v-validate="'required'"
          />

          <template slot="error" v-if="errors.has('password')">
            {{ errors.first("password") }}
          </template>
        </InputLabel>
      </div>

      <PrimaryButton class="password-recovery-reset__submit">
        {{ $t("auth.passwordReset.submit") }}
      </PrimaryButton>
    </form>
  </div>
</template>

<script>
import apiUser from "@/api/user";
import getError from "@/helpers/error";
import { PrimaryButton, InputLabel } from "@v2/shared/ui/components";

export default {
  name: "PasswordRecovery",

  components: { InputLabel, PrimaryButton },

  data() {
    return {
      password: "",
      error: ""
    };
  },

  methods: {
    resetPassword() {
      this.$validator.validate().then(result => {
        if (!result) {
          return;
        }

        apiUser
          .changeLostPassword({
            email: this.$route.query.email,
            token: this.$route.params.token,
            password: this.password,
            password_confirmation: this.password
          })
          .then(() => {
            this.$router.push({
              name: "login"
            });
          })
          .catch(response => {
            this.error = getError(response);
          });
      });
    }
  },

  created() {
    if (!this.$route.query.email || !this.$route.params.token) {
      this.$router.push({
        name: "password-recovery"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.password-recovery-reset {
  padding: 48px 80px 64px 80px;
  width: 460px;
  box-sizing: border-box;

  @include respond-down(md) {
    padding: 24px;

    width: calc(100vw - 16 * 2px);
    max-width: 375px;
    min-width: 288px;
  }

  &__title {
    @include h1();
    margin: 0 0 17px 0;

    @include respond-down(md) {
      font-size: 24px;
    }
  }

  &__submit {
    margin-top: 34px;
  }

  &__error-text {
    margin-bottom: 10px;
    font-size: 12px;
    color: #ea5330;
  }
}
</style>
